import { Box, ModBox, ModalDialog, Spacer, TextNew } from '@jfs/ui-new'
import { useIsFocused } from '@react-navigation/native'
import { FC, useCallback, useEffect, useState } from 'react'
import ActionsMenu from '../../comps/ActionMenu/ActionsMenu'
import { AddBeneficiary } from '../../comps/AddBeneficiary'
import EmptyView from '../../comps/EmptyView'
import { NewTable } from '../../comps/NewTable'
import { ActionType } from '../../comps/TableItem/types'
import { transactionScreenStrings } from '../../data/static/strings'
import { useLazyApiData, useStores } from '../../data/store'
import { Routes } from '../../nav/routes'
import { getCustomColumnWidth, getWidth, useWindowDimensions } from '../../util/util'
import { BeneficiaryDetails } from './BeneficiaryDetails'
import { BulkBeneficiary } from './BulkBeneficiary'
import { SingleBeneficiary } from './SingleBeneficiary'
import { styles } from './styles'

interface BeneficiaryOnboardingInterface {
  onDoneUpload: () => void
}

const BeneficiaryOnboarding: FC = ({ onDoneUpload }: BeneficiaryOnboardingInterface) => {
  const {
    getAllHistory,
    getBulkHistoryList,
    exportBeneficiaryReports,
    exportBulkBeneficiaryReport,
    selectedDateInfo,
    bulkSelectedDateInfo,
    updateSelectedDate,
    updateBulkSelectedDate,
    fetchAllBeneficiaries,
    fetchBulkBeneficiaryList,
    mid,
    resetPagination,
    fileUploadProgress,
    setUploadStatus,
    setFileUploadProgress,
    downloadSampleFile,
    setSize,
    setCount,
    downloadBulkOnboardingFile,
    pageNumber,
    canAddBeneficiary,
  } = useStores((root) => ({
    getAllHistory: root.beneficiaryOnboarding.getBeneficiaryAllHistory,
    getBulkHistoryList: root?.beneficiaryOnboarding.getBeneficiaryBulkHistory,
    exportBeneficiaryReports: root?.beneficiaryOnboarding.exportBeneficiaryReportsApi,
    exportBulkBeneficiaryReport: root?.beneficiaryOnboarding.exportBulkBeneficiaryReport,
    selectedDateInfo: root.beneficiaryOnboarding.selectedDate,
    bulkSelectedDateInfo: root.beneficiaryOnboarding.bulkSelectedDateInfo,
    updateSelectedDate: root.beneficiaryOnboarding.updateSelectedDate,
    updateBulkSelectedDate: root.beneficiaryOnboarding.updateBulkSelectedDate,
    fetchAllBeneficiaries: root.beneficiaryOnboarding.fetchAllBeneficiaries,
    fetchBulkBeneficiaryList: root.beneficiaryOnboarding.fetchBulkBeneficiaryList,
    mid: root?.user?.selectedMid,
    resetPagination: root.beneficiaryOnboarding.resetPagination,
    fileUploadProgress: root.settings.metaData.fileUploadProgress,
    setUploadStatus: root?.beneficiaryOnboarding.setUploadStatus,
    setFileUploadProgress: root.settings.metaData.setFileUploadProgress,
    downloadSampleFile: root.beneficiaryOnboarding.downloadSampleFile,
    setSize: root?.beneficiaryOnboarding?.setSize,
    setCount: root?.beneficiaryOnboarding?.setCount,
    downloadBulkOnboardingFile: root.beneficiaryOnboarding.downloadBulkOnboardingFile,
    pageNumber: root?.beneficiaryOnboarding.pagination.number,
    canAddBeneficiary: true,
  }))

  const [lazyFetchAllBeneficiaries, allBeneficiariesHandler] = useLazyApiData(fetchAllBeneficiaries)
  const [lazyFetchBulkBeneficiaries, bulkBeneficiariesHandler] = useLazyApiData(fetchBulkBeneficiaryList)

  const isFocused = useIsFocused()
  const viewPortWidth = useWindowDimensions()

  const [tabIndex, setSelectedTabIndex] = useState(0)
  const [fieldSettingVisible, setFieldSettingVisible] = useState(false)
  const [filterVisible, setFilterVisible] = useState(false)
  const [selectedMode, setSelectedMode] = useState('')
  const [fileName, setFileName] = useState('')
  const [file, setFile] = useState(null)
  const [showDetails, setShowDetails] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)
  const listData = tabIndex === 0 ? getAllHistory() : getBulkHistoryList()

  const fetchData = () => {
    if (tabIndex === 1) {
      lazyFetchBulkBeneficiaries(mid)
    } else {
      lazyFetchAllBeneficiaries(mid, '101')
    }
  }
  useEffect(() => {
    // resetPagination()
    fetchData()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabIndex])

  const handleRetry = () => {
    if (mid && isFocused) {
      fetchData()
    }
  }

  const getEmptyMessage = (): string => {
    return listData.length === 0 ? transactionScreenStrings.noRecords : transactionScreenStrings.empty
  }
  const scrollViewStyle = () => {
    if (listData.length === 0) {
      return styles.emptyContainer
    }
    return styles.tableContainer()
  }

  const handleDismiss = () => {
    setSelectedMode('')
  }

  const scrollStyle = scrollViewStyle()

  const resetState = (shouldNavigate?: boolean) => {
    console.log('resetState', resetState)
    setSelectedMode('')
    setUploadStatus('NOT_SELECTED')
    setFileName('')
    setFile(null)
    setSize(null)
    setFileUploadProgress(0)
    setCount(null)
    onDoneUpload && onDoneUpload()
    if (shouldNavigate) {
      if (tabIndex !== 1) {
        setSelectedTabIndex(1)
      } else {
        lazyFetchBulkBeneficiaries()
      }
    }
  }

  const onFileSelected = (name: string, size: number, selectedFile: any) => {
    setFileName(name)
    setSize(size)
    setFile(selectedFile)
    setUploadStatus('IN_PROGRESS')
  }
  const onHandleAddBeneficiaries = () => {
    console.log('onHandleAddBeneficiaries BeneficiaryOnboadig')
  }

  const closeDetailsView = () => {
    setShowDetails(false)
  }

  const renderBeneficiaryDetails = (data): React.ReactElement => {
    return <BeneficiaryDetails closeDetailsView={closeDetailsView} data={data} />
  }

  const onRowPress = (info: any) => {
    setSelectedItem(info)
    // setShowDetails(true)
  }

  const onDownloadAction = (actionType: ActionType, id: string) => {
    console.log('onDownloadAction actionType id', actionType, id)
    downloadBulkOnboardingFile(id)
  }

  const handleDownloadSamplefile = () => {
    // downloadSampleFile('sample_bulk_beneficiary_onboarding')
  }

  const handleExport = (type: string, _path: string, _selectedDateInfo: any) => {
    if (tabIndex === 0) {
      exportBeneficiaryReports(mid, type)
    } else {
      // exportBulkBeneficiaryReport(mid)
    }
  }

  const handleTabSelection = (tIndex: number) => {
    setSelectedTabIndex(tIndex)
  }

  const shouldShowEmptyView = useCallback(() => {
    return (
      (tabIndex === 0 && allBeneficiariesHandler.state !== 'fulfilled') ||
      (tabIndex === 1 && bulkBeneficiariesHandler.state !== 'fulfilled') ||
      listData?.length === 0
    )
  }, [allBeneficiariesHandler.state, bulkBeneficiariesHandler.state, listData?.length, tabIndex])

  const getErrorMessage = useCallback(() => {
    return (
      (tabIndex === 0 && allBeneficiariesHandler?.data?.message) ||
      (tabIndex === 1 && bulkBeneficiariesHandler?.data?.message)
    )
  }, [allBeneficiariesHandler?.data?.message, bulkBeneficiariesHandler?.data?.message, tabIndex])

  return (
    <Box {...styles.container}>
      <Box {...styles.flexRowView}>
        <TextNew title={'Beneficiary'} {...styles.titleText} />
        <ModBox show={canAddBeneficiary}>
          <AddBeneficiary selectedItem={setSelectedMode} valueSelected={'+ Add Beneficiary'} />
        </ModBox>
      </Box>
      <ActionsMenu
        path={Routes.PAYOUTS_BENEFICIARY}
        handleExport={handleExport}
        fetchDetailOfPath={fetchData}
        fieldSettingVisible={fieldSettingVisible}
        filterVisible={filterVisible}
        selectedDateInfo={tabIndex === 0 ? selectedDateInfo : bulkSelectedDateInfo}
        updateSelectedDate={tabIndex === 0 ? updateSelectedDate : updateBulkSelectedDate}
        maxRange={31}
        setFieldSettingVisible={setFieldSettingVisible}
        setFilterVisible={setFilterVisible}
        selectedTabIndex={tabIndex}
        setSelectedTabIndex={handleTabSelection}
        showFieldSettingsAndFilters={false}
        hideFieldSettings={false}
        hideExportButton={tabIndex === 1}
        showCalendarOnRight={true}
        apiHandler={tabIndex === 0 ? allBeneficiariesHandler : bulkBeneficiariesHandler}
      />
      <Spacer direction={'vertical'} size={16} />
      <ModBox h={'80%'} w={'100%'} align="center" justify="center" show={shouldShowEmptyView()}>
        <EmptyView
          onRetry={handleRetry}
          isLoading={
            (tabIndex === 0 && allBeneficiariesHandler.state === 'pending') ||
            (tabIndex === 1 && bulkBeneficiariesHandler.state === 'pending')
          }
          error={getErrorMessage()}
          emptyMessage={getEmptyMessage()}
          loadingMessage={''}
        />
      </ModBox>
      {!filterVisible && !fieldSettingVisible && !shouldShowEmptyView() && (
        <Box {...scrollStyle} nativeID={'scroll-horizontal-Table'} f={1}>
          <NewTable
            data={listData}
            onRowClick={onRowPress}
            rowHeight={48}
            headerHeight={64}
            customWidthFunc={getCustomColumnWidth}
            tableWidth={getWidth(viewPortWidth > 1200 ? viewPortWidth - 288 : viewPortWidth, listData?.[0])}
            headerRowKeys={
              tabIndex === 0
                ? {
                    beneficiaryName: 'Name',
                    mobileNumber: 'Phone Number',
                    beneficiaryId: 'Beneficiary ID',
                    accountNumber: 'Bank Account No',
                    emailId: 'Email ID',
                    subType: 'Type',
                  }
                : {
                    uploadDate: 'Upload Date/Time',
                    fileName: 'File Name',
                    totalCount: 'Total Beneficiary',
                    addedCount: 'Beneficiary Added',
                    declinedCount: 'Beneficiary Declined',
                    beneficiaryStatus: 'Beneficiary Status',
                    actionDownload: 'Download',
                  }
            }
            onAction={onDownloadAction}
          />
        </Box>
      )}
      <ModalDialog
        children={
          selectedMode === 'Single Beneficiary' ? (
            <SingleBeneficiary onClosePress={handleDismiss} mid={mid} />
          ) : (
            <BulkBeneficiary
              fileUploadProgress={fileUploadProgress}
              resetState={resetState}
              fileName={fileName}
              mid={mid}
              onFileSelected={onFileSelected}
              downloadSampleFile={handleDownloadSamplefile}
              file={file}
              onHandleAddBeneficiaries={onHandleAddBeneficiaries}
            />
          )
        }
        show={selectedMode?.length > 0}
        type={'Centered'}
        onDismiss={handleDismiss}
      />
      <ModalDialog
        children={renderBeneficiaryDetails(selectedItem)}
        show={showDetails}
        type={'Right'}
        onDismiss={closeDetailsView}
      />
    </Box>
  )
}

export default BeneficiaryOnboarding
